module.exports = __webpack_public_path__ + "fonts/euclid-square-400.3eeb44d6.ttf";